import { useSyncExternalStore } from 'react';
import { goToStation } from '@/lib/navigation';
import { netState, setOffline, subscribeNet } from '@/lib/net';
import { stations, tour, useTourStore } from '@/state/tour';

// which CV PDFs are in site/public, checked at build time
declare const __CV__: { de: boolean; en: boolean };

const [NAME, TAGLINE] = tour.title.split(' · ');

export function Header() {
  const activeIndex = useTourStore((s) => s.activeIndex);
  const net = useSyncExternalStore(subscribeNet, netState);

  return (
    <header className="header">
      <div className="brand">
        <span className="brand-name">{NAME}</span>
        {TAGLINE && <span className="brand-tagline">{TAGLINE}</span>}
      </div>
      <nav className="anchors" aria-label="Stations">
        {stations.map((s, i) => (
          <button
            key={s.id}
            type="button"
            aria-current={i === activeIndex ? 'step' : undefined}
            onClick={() => goToStation(i)}
          >
            {s.nav ?? s.title}
          </button>
        ))}
      </nav>
      <div className="header-actions">
        <Cv />
        <button
          type="button"
          className="offline-toggle"
          aria-pressed={net.offline}
          onClick={() => setOffline(!net.offline)}
        >
          offline
        </button>
        {net.offline && (
          <span className="net-badge" role="status">
            {net.blocked} {net.blocked === 1 ? 'request' : 'requests'} since toggle
          </span>
        )}
      </div>
    </header>
  );
}

function Cv() {
  if (!__CV__.de && !__CV__.en)
    return (
      <span className="cv" title="coming">
        CV (PDF) –
      </span>
    );
  const link = (lang: 'de' | 'en') =>
    __CV__[lang] ? (
      <a href={`/cv-${lang}.pdf`} download>
        {lang.toUpperCase()}
      </a>
    ) : (
      <span title="coming">–</span>
    );
  return (
    <span className="cv">
      CV (PDF) {link('de')}
      <span aria-hidden>|</span>
      {link('en')}
    </span>
  );
}
